







































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import verifyCode from './VerifyCode.vue'
@Component({
	components: {
		verifyCode
	}
})
export default class LoginForm extends Vue {
	@Prop ({
		type: Boolean,
		default: true
	}) private logoFlag!: boolean
	private ruleForm: {
		userName: string | undefined,
		phone: string | undefined,
		code: string | undefined,
		verifyImgCode: string | undefined
	} = {
		userName: '',
		phone: '',
		code: '',
		verifyImgCode: ''
	}
	private uuid: string = (this as any).$fxUtils.createUUID()
	private verifyCodeImgUrl: string = ''
	private rules: object = {
		userName: [{ validator: this.validateUserName, trigger: 'blur' }],
		phone: [{ validator: this.validatePhone, trigger: 'blur' }],
		code: [{ validator: this.validateCode, trigger: 'blur' }],
		verifyImgCode: [{ validator: this.validateVerifyImgCode, trigger: 'blur' }]
	}
	private validateUserName (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('企业名称不能为空'))
		} else if (!(this as any).$fxUtils.regChinese().test(value)) {
			callback(new Error('企业名称只能是汉字'))
		} else if (value.length > 30) {
			callback(new Error('企业名称最大长度为30个字符'))
		} else {
			callback()
		}
	}
	private validatePhone (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('手机号码不能为空'))
		} else if (!(this as any).$fxUtils.regPhone().test(value)) {
			callback(new Error('手机号码格式不正确'))
		} else {
			callback()
		}
	}
	private validateCode (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('验证码不能为空'))
		} else if (!(this as any).$fxUtils.regVerifyCode().test(value)) {
			callback(new Error('验证码为四位数字'))
		} else {
			callback()
		}
	}
	private validateVerifyImgCode (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('请输入图形验证码'))
		} else {
			callback()
		}
	}
	@Watch('uuid', { immediate: true })
	private onUuidChange (val: any, oldVal: any) {
		this.verifyCodeImgUrl = `/cldEdi/business/${val}/getVerifyCode`
	}
	private refreshVerifyImgCode () {
		this.uuid = (this as any).$fxUtils.createUUID()
	}
	private onRegisterClick (ruleForm: string): void {
		(this.$refs[ruleForm] as any).validate().then((valid: any) => {
			this.$emit('on-register', this.ruleForm)
		})
	}
	private onCellInputEnter (arg: any, prop: string): void {
		if (prop === 'submit') {
			this.onRegisterClick('ruleForm')
		} else {
			(this.$refs[prop] as any).focus()
		}
	}
	private onLoginClick (): void {
		this.$emit('on-login-click')
	}
	private onForgotPasswordClick (): void {
		this.$emit('on-forgotPassword-click')
	}
	private beforeVerifyImgCodeClick () {
		let validPass = true
		return new Promise((resolve: any) => {
			(this.$refs.ruleForm as any).validateField(['phone', 'verifyImgCode'], (res: any) => {
				if (res) {
					validPass = false
				}
			})
			if (validPass) {
				resolve()
			}
		})
	}
}
